export const GENRES = [
  "R&B", "Soul", "Slow Jams", "Hip-Hop", "Reggae", "Soca", "Dancehall", "Disco",
  "Gospel", "Jazz", "Pop", "Rock", "Country", "Afrobeats", "Talk Radio", "News",
  "Mixed Format", "Other",
];

export const STATION_TYPES = [
  { v: "internet", l: "Internet radio" }, { v: "fm", l: "FM" }, { v: "am", l: "AM" },
  { v: "podcast_network", l: "Podcast network" }, { v: "satellite", l: "Satellite" },
  { v: "other", l: "Other" },
];

export const LANGUAGES = [
  "English", "Spanish", "French", "German", "Portuguese", "Italian", "Dutch",
  "Patois / Creole", "Swahili", "Yoruba", "Hindi", "Arabic", "Mandarin", "Japanese", "Other",
];

export const COUNTRIES = [
  "United States", "United Kingdom", "Canada", "Jamaica", "Trinidad & Tobago", "Barbados",
  "Bahamas", "Germany", "France", "Netherlands", "Spain", "Italy", "Switzerland", "Austria",
  "Ireland", "Australia", "New Zealand", "Nigeria", "Ghana", "Kenya", "South Africa",
  "Brazil", "Mexico", "Colombia", "India", "Japan", "Philippines", "Singapore", "Other",
];

export const TONES = [
  "Professional", "Energetic", "Friendly", "Romantic", "Smooth", "Urban",
  "Humorous", "Informative", "Luxury", "Custom",
];

export const DJ_PERSONALITIES = [
  "Smooth and romantic", "Energetic and exciting", "Friendly and conversational",
  "Professional announcer", "Urban and modern", "Caribbean personality",
  "Classic radio personality", "Humorous", "Calm and relaxing", "Custom",
];

export const BROADCAST_PROVIDERS = [
  { v: "sam_broadcaster_pro", l: "SAM Broadcaster PRO", fields: ["stream_url", "metadata_url", "username", "password"] },
  { v: "sam_cloud", l: "SAM Cloud", fields: ["stream_url", "station_ref", "api_key"] },
  { v: "shoutcast", l: "Shoutcast", fields: ["server_url", "port", "stream_url", "password"] },
  { v: "icecast", l: "Icecast", fields: ["server_url", "mount_point", "port", "username", "password"] },
  { v: "azuracast", l: "AzuraCast", fields: ["server_url", "station_ref", "api_key"] },
  { v: "radio_co", l: "Radio.co", fields: ["station_ref", "api_key"] },
  { v: "live365", l: "Live365", fields: ["stream_url", "api_key"] },
  { v: "airtime_pro", l: "Airtime Pro", fields: ["server_url", "api_key"] },
  { v: "custom", l: "Custom metadata URL", fields: ["metadata_url"] },
  { v: "manual", l: "Manual entry", fields: [] },
  { v: "not_ready", l: "Not ready yet", fields: [] },
];

export const BROADCAST_FIELD_LABELS = {
  stream_url: "Stream URL", metadata_url: "Metadata URL", server_url: "Server URL",
  station_ref: "Station ID", mount_point: "Mount point", port: "Port",
  username: "Username", password: "Password", api_key: "API key",
};

export const CONTENT_TYPES = [
  "Now Playing social posts", "Artist biographies", "Song facts", "AI DJ scripts",
  "Station liners", "Sweepers", "News bulletins", "Weather reports", "Podcast titles",
  "Podcast descriptions", "Podcast show notes", "WordPress articles",
  "Social-media captions", "Hashtags", "Promotional advertisements",
  "Sponsor messages", "Video scripts", "Email newsletters",
];

export const SAMPLE_CONTENT_TYPES = [
  { v: "welcome_post", l: "Welcome social-media post" },
  { v: "station_description", l: "Station description" },
  { v: "dj_intro", l: "AI DJ introduction" },
  { v: "now_playing_template", l: "Now Playing template" },
  { v: "promo_post", l: "Promotional post" },
  { v: "launch_article", l: "WordPress station-launch article" },
];

export const AUTOMATIONS = [
  { k: "now_playing_posts", l: "Automatic Now Playing posts" },
  { k: "artist_info", l: "Automatic artist information" },
  { k: "wordpress_posts", l: "Automatic WordPress posts" },
  { k: "podcast_creation", l: "Automatic podcast creation" },
  { k: "social_scheduling", l: "Automatic social-media scheduling" },
  { k: "news_generation", l: "Automatic news generation" },
  { k: "weather_reports", l: "Automatic weather reports" },
  { k: "show_notes", l: "Automatic show notes" },
  { k: "promo_posts", l: "Automatic promotional posts" },
];

export const EXCLUDE_TYPES = [
  "Station IDs", "Sweepers", "Commercials", "Advertisements", "Jingles",
  "Unknown metadata", "Blank metadata",
];

export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook Pages" },
  { key: "instagram", label: "Instagram Business" },
  { key: "tiktok", label: "TikTok" },
  { key: "youtube", label: "YouTube" },
  { key: "x", label: "X" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "wordpress", label: "WordPress" },
  { key: "whatsapp", label: "WhatsApp" },
];

export const TIMEZONES = (() => {
  try { return Intl.supportedValuesOf("timeZone"); }
  catch { return ["UTC", "America/New_York", "America/Chicago", "America/Los_Angeles", "Europe/London", "Europe/Berlin", "America/Jamaica", "Africa/Lagos", "Australia/Sydney"]; }
})();
